<template>
  <div class="w-100 p-1">
  <SelfieCamera/>
  </div>
</template>

<script>
import SelfieCamera from './components/SelfieCamera.vue'

export default {
  name: 'App',
  components: {
    SelfieCamera
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
